var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarCallassistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.38,23.25A26.63,26.63,0,0,1,12.45,17c-2.8-3.53-2.32-5.44-1.72-6L12,9.78a1.63,1.63,0,0,0,.15-2.14L8.53,3.08a1.35,1.35,0,0,0-2-.16C6.51,3,5.22,4.18,5.2,4.2,3.4,6,2.85,8.83,3.62,12.31a23.1,23.1,0,0,0,4.63,9.14,45.84,45.84,0,0,0,7.93,6.79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.53,14.65c0-2.14-1.42-3.86-3.19-3.86s-3.17,1.72-3.17,3.86,1.41,3.87,3.17,3.87S27.53,16.79,27.53,14.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.57,24.71v3.2h9.56v-3.2c0-3-3.19-4.48-4.78-4.48S19.57,21.73,19.57,24.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarCallassistant);
export default __webpack_public_path__ + "static/media/toolbar-callassistant.76e187ed.svg";
export { ForwardRef as ReactComponent };